/**
 * Flow name section — Voluum-style identity + routing defaults
 * For Media Devoted | Created By Ciro Autiero
 */

import { type FC } from 'react';
import type { VoluumFlowUpdate } from '@trafficpulse/shared';

import SectionShell from '../SectionShell';
import {
  FlowNameFields,
  FlowNotesCampaigns,
  FlowRoutingFields,
} from './panel';

export interface FlowMetaSectionProps {
  flowId: string;
  draft: VoluumFlowUpdate;
  onPatch: (mutator: (d: VoluumFlowUpdate) => void) => void;
}

const FlowMetaSection: FC<FlowMetaSectionProps> = ({
  flowId,
  draft,
  onPatch,
}) => (
  <SectionShell title="Flow name" collapsible dense defaultExpanded={false}>
    <FlowNameFields draft={draft} onPatch={onPatch} />
    <FlowRoutingFields draft={draft} onPatch={onPatch} />
    <FlowNotesCampaigns flowId={flowId} draft={draft} onPatch={onPatch} />
  </SectionShell>
);

export default FlowMetaSection;
